import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import * as Sentry from '@sentry/react'
import { browserProfilingIntegration, replayIntegration } from '@sentry/react'
import { initAnalytics } from './services/analyticsManager'
import { initHotjar } from './services/hotjar'

// Initialize Sentry for error tracking (production only, to keep dev noise out of the project)
if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://bc473d2cf344dfc89cd61ae616fad3cf@o4509063784628224.ingest.us.sentry.io/4509063786070016',
    environment: import.meta.env.MODE,
    integrations: [browserProfilingIntegration(), replayIntegration()],
    // Performance Monitoring
    tracesSampleRate: 0.2,
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}

const SentryApp = Sentry.withProfiler(App)

// Initialize analytics
const initializeApp = async () => {
  try {
    // Initialize analytics tracking with unified manager
    initAnalytics()

    // Initialize Hotjar
    initHotjar()
  } catch (error) {
    console.error('Failed to initialize analytics:', error)
    // Continue app initialization even if analytics init fails
    // This ensures the app works without analytics in fallback mode
  }

  // Render the application
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <Sentry.ErrorBoundary fallback={<div>An error has occurred</div>}>
        <SentryApp />
      </Sentry.ErrorBoundary>
    </React.StrictMode>
  )
}

// Start initialization
initializeApp()
